import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
 
 
 
 
export default function FaturamentoPresumido({
  faturamentos
}: {
  faturamentos: any
}) {
  const { t } = useTranslation();
  
  return (
    <Panel header={t('faturamentoPresumido')}>
       {faturamentos[0].mensagemErro ?  (
        <p>{faturamentos[0].mensagemErro}</p>
       ) : ( 
        <div>
       <DataTable size="small" emptyMessage="Nenhuma informação disponível" value={faturamentos} tableStyle={{ minWidth: '50rem' }}>
          <Column field="data" header={t('data')}></Column>
          <Column field="valor" header={t('valor')}></Column>
          <Column field="faixa" header={t('faixaFaturamento')}></Column>
          <Column field="subFaixa" header={t('subFaixaFaturamento')}></Column>
          <Column field="porte" header={t('porte')}></Column>
      </DataTable>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
        <p>O porte da empresa é definido por dados financeiros e dados referentes a capacidade produtiva. O faturamento
        anual é o indicador mais utilizado no Brasil para classificação</p>
        </div>
      </div>
      </div>
       )}
    </Panel>
  )
}